import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./page/Home";
import More from "./page/More/More";
import Catalog from "./page/Products/Products";
import Reviews from "./page/Reviews/Reviews";
import Contact from "./page/Contact/Contact";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [language, setLanguage] = useState(localStorage.getItem("language"));

  const GetPage = (e) => {
    const page = document.querySelector(e.target.href.split("/")[3]).offsetTop;
    window.scrollTo({
      top: page - 100,
      left: 0,
      behavior: "smooth",
    });
  };

  if (
    localStorage.getItem("language") !== "uz" &&
    localStorage.getItem("language") !== "ru"
  ) {
    localStorage.setItem("language", "uz");
  }

  const getLang = (lang) => {
    if (lang === "uz" || lang === "ru") {
      setLanguage(localStorage.setItem("language", lang));
    }
  };
  useEffect(() => {
    getLang();
  }, []);

  const [home, setHome] = useState("");

  const GetHome = async (e) => {
    setInterval(() => {
      setHome(window.location.pathname === "/");
    }, 1000);
  };

  useEffect(() => {
    GetHome();
  }, []);

  // Product Cart

  const [productNumbers, setProductNumbers] = useState("");
  const [productsInCart, setProductsInCart] = useState("");
  const [totalCoastGet, setTotalCoastGet] = useState("");

  function getLocals() {
    setProductNumbers(localStorage.getItem("cartNumbers"));
    setProductsInCart(localStorage.getItem("productsInCart"));
    setTotalCoastGet(localStorage.getItem("totalCoast"));
  }
  useEffect(() => {
    getLocals();
  }, []);

  function cartNumbers(item) {
    setProductNumbers(localStorage.getItem("cartNumbers"));
    if (productNumbers) {
      localStorage.setItem("cartNumbers", +productNumbers + 1);
    } else {
      localStorage.setItem("cartNumbers", 1);
    }
    setItems(item);
    totalCoast(item);
    setProductNumbers(localStorage.getItem("cartNumbers"));
  }

  function setItems(product) {
    let cartItems = localStorage.getItem("productsInCart");
    cartItems = JSON.parse(cartItems);
    if (cartItems != null) {
      if (cartItems[product.id] === undefined) {
        product.inCart = 0;
        cartItems = {
          ...cartItems,
          [product.id]: product,
        };
      }
      cartItems[product.id].inCart += 1;
    } else {
      product.inCart = 1;
      cartItems = {
        [product.id]: product,
      };
    }
    localStorage.setItem("productsInCart", JSON.stringify(cartItems));
    setProductsInCart(localStorage.getItem("productsInCart"));
  }

  function totalCoast(product) {
    let cartCoast = localStorage.getItem("totalCoast");
    if (cartCoast !== null) {
      localStorage.setItem("totalCoast", +cartCoast + +product.price);
      setTotalCoastGet(localStorage.getItem("totalCoast"));
    } else {
      localStorage.setItem("totalCoast", product.price);
      setTotalCoastGet(localStorage.getItem("totalCoast"));
    }
  }

  function minusNumber(item) {
    setProductNumbers(localStorage.getItem("cartNumbers"));
    if (productNumbers) {
      localStorage.setItem("cartNumbers", +productNumbers - 1);
    }
    setItemsMinus(item);
    totalCoastMinus(item);
    setProductNumbers(localStorage.getItem("cartNumbers"));
  }

  function setItemsMinus(product) {
    let cartItems = localStorage.getItem("productsInCart");
    cartItems = JSON.parse(cartItems);
    if (cartItems != null) {
      if (cartItems[product.id] === undefined) {
        cartItems = {
          ...cartItems,
          [product.id]: product,
        };
      }
      cartItems[product.id].inCart -= 1;
    } else {
      product.inCart -= 1;
      cartItems = {
        [product.id]: product,
      };
    }
    if (cartItems[product.id].inCart < 1) {
      delete cartItems[product.id];
    }
    localStorage.setItem("productsInCart", JSON.stringify(cartItems));
    setProductsInCart(localStorage.getItem("productsInCart"));
  }

  function totalCoastMinus(product) {
    let cartCoast = localStorage.getItem("totalCoast");
    if (cartCoast !== null) {
      localStorage.setItem("totalCoast", +cartCoast - +product.price);
      setTotalCoastGet(localStorage.getItem("totalCoast"));
    }
  }

  const [toggle, setToggle] = useState(false);
  const [checkout, setCheckout] = useState(false);
  const [oneClick, setOneClick] = useState("");
  const [oneClickProduct, setOneClickProduct] = useState("");
  const [mediaBars, setMediaBars] = useState(true)

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Navbar
        GetPage={GetPage}
        oneClick={oneClick}
        oneClickProduct={oneClickProduct}
        setOneClickProduct={setOneClickProduct}
        setOneClick={setOneClick}
        toggle={toggle}
        setToggle={setToggle}
        checkout={checkout}
        setCheckout={setCheckout}
        cartNumbers={cartNumbers}
        GetHome={GetHome}
        totalCoastGet={totalCoastGet}
        productsInCart={productsInCart}
        home={home}
        language={language}
        minusNumber={minusNumber}
        setLanguage={setLanguage}
        getLang={getLang}
        mediaBars={mediaBars}
        setMediaBars={setMediaBars}
        productNumbers={productNumbers}
      />
      <Routes>
        <Route path="/" element={<Home GetHome={GetHome} />} />
        <Route
          path="/more/*"
          element={
            <More
              oneClick={oneClick}
              setOneClick={setOneClick}
              oneClickProduct={oneClickProduct}
              setOneClickProduct={setOneClickProduct}
              toggle={toggle}
              setToggle={setToggle}
              checkout={checkout}
              setCheckout={setCheckout}
              cartNumbers={cartNumbers}
              productNumbers={productNumbers}
              setProductNumbers={setProductNumbers}
              productsInCart={productsInCart}
              setProductsInCart={setProductsInCart}
              totalCoastGet={totalCoastGet}
              setTotalCoastGet={setTotalCoastGet}
            />
          }
        />
        <Route path="/*" element={<Navigate to="/" />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
